export default[
  {
    label: "Approved",
    value: "39"
  },
  {
    label: "Pending",
    value: "82"
  },
  {
    label: "Rejected",
    value: "17"
  }
]
